export default __webpack_public_path__ + "static/media/warning--trail-crossing--g6.5ae959ad.png";